<template>
  <div class="auto-set">
    <div class="box">
      <el-page-header @back="$router.go(-1)" content="自动随机组卷">
      </el-page-header>
      <el-form
        :model="form"
        :rules="rules"
        ref="ruleForm"
        style="margin-top: 20px"
        size="small"
        label-width="110px"
        label-position="left"
      >
        <el-form-item
          prop="randomNum"
          label="随机组卷数量"
          :inline-message="true"
        >
          <el-input-number
            v-model="form.randomNum"
            :controls="false"
            :min="1"
          ></el-input-number>
        </el-form-item>
        <el-form-item prop="title" label="试卷标题">
          <el-input
            v-model="form.title"
            placeholder="请输入试卷标题"
          ></el-input>
        </el-form-item>
        <el-form-item prop="full" label="满分" :inline-message="true">
          <el-input-number
            v-model="form.full"
            :controls="false"
            :min="0"
          ></el-input-number>
        </el-form-item>
        <el-form-item
          prop="chapterId"
          label="题目所属章节"
          :inline-message="true"
        >
          <el-cascader
            v-model="form.chapterIds"
            :options="chapters"
            @change="getTypeNum"
            :props="{
              label: 'title',
              value: 'chapterId',
              emitPath: false,
              multiple: true,
            }"
            :show-all-levels="false"
            placeholder="请选择章节"
            collapse-tags
            clearable
          ></el-cascader>
        </el-form-item>

        <div class="types">
          <div
            class="one"
            v-for="(item, idx) in form.questionTypeList"
            :key="idx"
          >
            <div class="head">
              <h4>{{ checkType(item.type) }}</h4>
              <i class="el-icon-delete" @click="handleDel(idx)"></i>
            </div>
            <div class="main">
              <el-form-item
                :prop="'questionTypeList.' + idx + '.score'"
                :rules="rules.score"
                label="总分"
                :inline-message="true"
              >
                <el-input-number
                  v-model="item.score"
                  :controls="false"
                  :min="0"
                ></el-input-number>
              </el-form-item>
              <el-form-item
                :prop="'questionTypeList.' + idx + '.num'"
                :rules="rules.num"
                label="从题库选题"
                :inline-message="true"
              >
                <el-input-number
                  v-model="item.num"
                  :controls="false"
                  :max="typeMax(item.type)"
                  :min="0"
                ></el-input-number>
                / {{ typeMax(item.type) }}
              </el-form-item>
            </div>
          </div>
          <el-button
            type="primary"
            icon="el-icon-plus"
            size="small"
            plain
            @click="showAdd = true"
            >添加题型</el-button
          >
        </div>
      </el-form>

      <div class="bottom">
        <p style="float: left">
          满分: {{ form.full || 0 }}, 当前总分:
          <span style="color: red">{{ currentTotal }}</span>
        </p>
        <el-button
          style="float: right"
          type="primary"
          size="medium"
          @click="handleSubmit('ruleForm')"
          >保存</el-button
        >
      </div>
    </div>
    <el-dialog title="选择题型" :visible.sync="showAdd" width="30%" center>
      <el-checkbox-group v-model="checkList">
        <el-checkbox
          v-for="item in list"
          :key="item"
          :label="item"
          :disabled="isExist(item)"
          style="margin-bottom: 10px"
          >{{ checkType(item) }}</el-checkbox
        >
      </el-checkbox-group>
      <span slot="footer" class="dialog-footer">
        <el-button size="medium" @click="showAdd = false">取 消</el-button>
        <el-button type="primary" size="medium" @click="handleAdd"
          >确定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { checkType, handleTree } from "@/utils/index";
import { randomSet } from "@/api/exam";
import { typeQuestionNum } from "@/api/questionBank";
import { chapterList } from "@/api/chapter";

export default {
  data() {
    var validateFull = (rule, value, callback) => {
      if (!value && value != 0) {
        callback(new Error("请填写满分分值"));
      } else if (value !== this.currentTotal) {
        callback(new Error("满分和当前总分不匹配"));
      }
      callback();
    };
    return {
      checkType,
      chapters: [],
      form: {
        classId: this.$route.query.id,
        chapterIds: [],
        randomNum: undefined,
        title: "",
        full: undefined,
        questionTypeList: [
          {
            type: "RADIO",
            score: undefined,
            num: undefined,
          },
          {
            type: "CHECKBOX",
            score: undefined,
            num: undefined,
          },
          {
            type: "BOOLEAN",
            score: undefined,
            num: undefined,
          },
        ],
      },
      showAdd: false,
      list: ["RADIO", "CHECKBOX", "BOOLEAN", "SUPPLY", "ANSWER"],
      checkList: [],
      rules: {
        randomNum: {
          required: true,
          message: "请填写随机组卷数量",
          trigger: "blur",
        },
        title: {
          required: true,
          message: "请输入试卷标题",
          trigger: "blur",
        },
        full: { required: true, validator: validateFull, trigger: "blur" },
        score: {
          required: true,
          message: "请输入题型总分",
          trigger: "blur",
        },
        num: {
          required: true,
          message: "请输入选题数量",
          trigger: "blur",
        },
      },
      typeNum: {},
    };
  },
  created() {
    let arr = [];
    this.form.questionTypeList.forEach((item) => {
      arr.push(item.type);
    });
    this.checkList = arr;
    this.getTypeNum();
    this.getChapterList();
  },
  computed: {
    currentTotal() {
      return this.form.questionTypeList.reduce((prev, curr) => {
        return (curr.score || 0) + prev;
      }, 0);
    },
  },
  methods: {
    // 章节列表
    getChapterList() {
      chapterList({ classId: this.$route.query.id }).then((res) => {
        if (res.code == 0) {
          this.chapters = handleTree(res.data, "chapterId");
        } else {
          console.log(res.msg);
        }
      });
    },
    // 题型题目数量
    getTypeNum() {
      typeQuestionNum({
        courseId: this.$route.query.courseId,
        chapterIds: this.form.chapterIds.join(','),
      }).then(({ code, data, msg }) => {
        if (code == 0) {
          this.typeNum = data;
        } else {
          console.log(msg);
        }
      });
    },
    typeMax(type) {
      return this.typeNum[type];
    },
    handleDel(idx) {
      this.form.questionTypeList.splice(idx, 1);
    },
    isExist(type) {
      return this.form.questionTypeList.some((item) => {
        return item.type == type;
      });
    },
    // 增加题型
    handleAdd() {
      this.checkList.forEach((item) => {
        this.isExist(item) ||
          this.form.questionTypeList.push({
            type: item,
            score: undefined,
            num: undefined,
          });
      });
      this.showAdd = false;
    },
    // 保存
    handleSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$loading.show();
          randomSet(this.form).then(({ code, msg }) => {
            this.$loading.hide();
            if (code == 0) {
              this.$message.success("组卷成功");
              this.$router.replace({
                path: "/classCourse/exam/examBank",
                query: {
                  ...this.$route.query,
                },
              });
            } else {
              this.$message.error(msg);
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.auto-set {
  height: 100%;
  text-align: left;

  .box {
    padding: 25px 35px;
    background-color: #fff;
    ::v-deep .el-page-header {
      .el-page-header__content {
        font-size: 16px;
      }
    }
    .el-input-number {
      width: 80px;
    }

    .types {
      .one {
        margin: 10px 0;
        border: 1px solid #f2f2f2;
        border-radius: 8px;
        .head {
          padding: 10px;
          border-bottom: solid 1px #f2f2f2;
          overflow: hidden;
          h4 {
            float: left;
          }
          .el-icon-delete {
            float: right;
            font-size: 16px;
            color: #909399;
            cursor: pointer;
          }
        }
        .main {
          padding: 10px;
        }
      }
    }

    .bottom {
      margin-top: 20px;
      line-height: 36px;
      overflow: hidden;
    }
  }
}
</style>